export const getters = {
  systemPayments: state => state.payments
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/payments/getters.js